import { IPrepaidProgramFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidProgram/PrepaidProgramMeta';
import { CustomButton, CustomTextInput, CustomInputSelect } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import MiscellaneousPeriodicFeesTabPanelFormUI from "./PrepaidProgramTabPanels/MiscellaneousPeriodicFeesTabPanelFormUI";
import ProgramParametersTabPanelFormUI from "./PrepaidProgramTabPanels/ProgramParametersTabPanelFormUI";
import RechargeParametersTabPanelFormUI from "./PrepaidProgramTabPanels/RechargeParametersTabPanelFormUI";

type Props = {
  onSubmit: any,
  meta: IPrepaidProgramFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
  data: any, 
  columns: any,
} 

const PrepaidProgramFormUI = ({onSubmit, isLoading, isSubmitting, meta, data, columns}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>        
        <CC.Box my="4">          
            <CC.Box shadow={"md"}
             width={'100%'} p={5} mb={5} >
              <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:2}} spacing={10}>              
                <CustomFormControl isInvalid={!!errors[meta.idBank.name]} label={meta.idBank.label}>
                  <CustomTextInput
                    meta={meta.idBank}
                    register={register(meta.idBank.name)}
                    hasError={errors[meta.idBank.name]}
                  />
                </CustomFormControl>

                <CustomFormControl isInvalid={!!errors[meta.nameBank.name]} label={meta.nameBank.label} mx={{ md: 2 }}>
                  <CustomTextInput
                    meta={meta.nameBank}
                    register={register(meta.nameBank.name)}
                    hasError={errors[meta.nameBank.name]}
                  />
                </CustomFormControl>
              </CC.SimpleGrid>
            </CC.Box>

            <CC.Box shadow={"md"}
            width={'100%'} p={5} mb={5} >
              <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10}>              
                <CustomFormControl isInvalid={!!errors[meta.idItem.name]} label={meta.idItem.label}>
                  <CustomTextInput
                    meta={meta.idItem}
                    register={register(meta.idItem.name)}
                    hasError={errors[meta.idItem.name]}
                  />
                </CustomFormControl>

                <CustomFormControl isInvalid={!!errors[meta.nameItem.name]} label={meta.nameItem.label} mx={{ md: 2 }}>
                  <CustomTextInput
                    meta={meta.nameItem}
                    register={register(meta.nameItem.name)}
                    hasError={errors[meta.nameItem.name]}
                  />
                </CustomFormControl>  

                <CustomFormControl
                  label={meta.target.label}
                  isLoading={isLoading}
                  isInvalid={!!errors[meta.target.name]}
                >
                  <CustomInputSelect
                    meta={meta.target}
                    register={register(meta.target.name)}
                    hasError={errors[meta.target.name]}
                  />
                </CustomFormControl>

                <CustomFormControl
                  label={meta.category.label}
                  isLoading={isLoading}
                  isInvalid={!!errors[meta.category.name]}
                >
                  <CustomInputSelect
                    meta={meta.category}
                    register={register(meta.category.name)}
                    hasError={errors[meta.category.name]}
                  />
                </CustomFormControl>

                <CustomFormControl isInvalid={!!errors[meta.startDate.name]} label={meta.startDate.label} mx={{ md: 2 }}>
                  <CustomTextInput
                    meta={meta.startDate}
                    register={register(meta.startDate.name)}
                    hasError={errors[meta.startDate.name]}
                  />
                </CustomFormControl>
                <CustomFormControl isInvalid={!!errors[meta.endDate.name]} label={meta.endDate.label} mx={{ md: 2 }}>
                  <CustomTextInput
                    meta={meta.endDate}
                    register={register(meta.endDate.name)}
                    hasError={errors[meta.endDate.name]}
                  />
                </CustomFormControl> 
            </CC.SimpleGrid>
          </CC.Box>

          <CC.Box shadow={"md"}
          width={'100%'} px={5} mb={5} >
          <CC.Tabs>
            <div style={{overflow: 'auto'}}>
              <CC.TabList>
                <CC.Tab minWidth={'fit-content'}>Paramètres programme</CC.Tab>
                <CC.Tab minWidth={'fit-content'}>Paramètres de recharge</CC.Tab>
                <CC.Tab minWidth={'fit-content'}>Frais périodiques divers</CC.Tab>
              </CC.TabList>
            </div>

            <CC.TabPanels>

              {/* Parametres programme */}
              <CC.TabPanel>
                <ProgramParametersTabPanelFormUI
                meta={meta}
                register={register}
                errors={errors}
                isLoading={isLoading} 
                />
              </CC.TabPanel>

              {/* Parametres de recharge */}
              <CC.TabPanel>
                <RechargeParametersTabPanelFormUI
                meta={meta}
                register={register}
                errors={errors}
                isLoading={isLoading} 
                />
                {/* <AddressFormHandler /> */}
              </CC.TabPanel>
              
              {/* Frais périodiques divers */}
              <CC.TabPanel>
                <MiscellaneousPeriodicFeesTabPanelFormUI
                meta={meta}
                register={register}
                errors={errors}
                isLoading={isLoading}
                data={data}
                columns={columns}
                />
                
              </CC.TabPanel>

            </CC.TabPanels>
          </CC.Tabs>
          </CC.Box>

          

          <CC.Flex justify={'flex-end'}>
            <CustomButton isLoading={isSubmitting} type="submit">
              <span>Enregistrer</span>
            </CustomButton>
          </CC.Flex>
        </CC.Box>
      </form>
    </>    
  )
}

export default PrepaidProgramFormUI;